import { formatMinor, parseIso, toIso } from '@apka/core'
import type { IsoDate } from '@apka/core'

/** Formatowanie złotówek — jedyne miejsce, w którym aplikacja zamienia grosze na tekst. */
export function zl(minor: number): string {
  return formatMinor(minor, 'PLN')
}

export function waluta(minor: number, kod: string): string {
  return formatMinor(minor, kod)
}

export const MIESIACE = [
  'styczeń',
  'luty',
  'marzec',
  'kwiecień',
  'maj',
  'czerwiec',
  'lipiec',
  'sierpień',
  'wrzesień',
  'październik',
  'listopad',
  'grudzień',
] as const

export const MIESIACE_DOPELNIACZ = [
  'stycznia',
  'lutego',
  'marca',
  'kwietnia',
  'maja',
  'czerwca',
  'lipca',
  'sierpnia',
  'września',
  'października',
  'listopada',
  'grudnia',
] as const

export const MIESIACE_SKROT = [
  'sty',
  'lut',
  'mar',
  'kwi',
  'maj',
  'cze',
  'lip',
  'sie',
  'wrz',
  'paź',
  'lis',
  'gru',
] as const

export const DNI_SKROT = ['pon', 'wt', 'śr', 'czw', 'pt', 'sob', 'ndz'] as const

export function skrotMiesiaca(data: IsoDate): string {
  return MIESIACE_SKROT[parseIso(data).month - 1] ?? ''
}

export function nazwaMiesiaca(miesiac: number): string {
  return MIESIACE[miesiac - 1] ?? ''
}

/** „5 sierpnia" — zapis, który czyta się naturalnie w liście płatności. */
export function dzienIMiesiac(data: IsoDate): string {
  const { month, day } = parseIso(data)
  return `${day} ${MIESIACE_DOPELNIACZ[month - 1] ?? ''}`
}

export function pelnaData(data: IsoDate): string {
  const { year, month, day } = parseIso(data)
  return `${day} ${MIESIACE_DOPELNIACZ[month - 1] ?? ''} ${year}`
}

/** Dzień tygodnia liczony od poniedziałku (0) do niedzieli (6). */
export function dzienTygodnia(data: IsoDate): number {
  const { year, month, day } = parseIso(data)
  return (new Date(Date.UTC(year, month - 1, day)).getUTCDay() + 6) % 7
}

export function przesunMiesiac(rok: number, miesiac: number, o: number): { rok: number; miesiac: number } {
  const razem = rok * 12 + (miesiac - 1) + o
  return { rok: Math.floor(razem / 12), miesiac: (razem % 12) + 1 }
}

export function kluczMiesiaca(rok: number, miesiac: number): string {
  return toIso(rok, miesiac, 1).slice(0, 7)
}

const CZAS = new Intl.DateTimeFormat('pl-PL', {
  dateStyle: 'short',
  timeStyle: 'short',
})

export function znacznikCzasu(iso: string): string {
  return CZAS.format(new Date(iso))
}
